import { Card } from "@mui/material";
import * as S from "./style";

function MainPanel() {
  return (
    <S.MainPanelStyle>
      <Card className="panel">
        <h2>Sistema de Cadastro de Pessoas</h2>
        <p>Versão 1.2</p>
      </Card>
    </S.MainPanelStyle>
  );
}

export default MainPanel;
